import ChangePassword from "../components/changePassword";
import Login from "../components/login";
import Footer from "../components/footer";
import Navbar from "../components/navbar";
import Sidebar from "../components/sidebar";

function ChangePasswordPage() {
  return (
    <>
      <Sidebar>
        <ChangePassword />
      </Sidebar>
    </>
  );
}
export default ChangePasswordPage;
